import { YStack } from "tamagui";
import FamilyExpenses from "./components/wallet/FamilyExpenses";
import TransactionHistory from "./components/wallet/TransactionHistory";
import { getColor } from "@utils/func/colorTool";
const FAMILY_SPENDING_DATA = [
  {
    label: "台中家",
    e: "T",
    color: getColor(0).bgColor,
    amount: 1310,
  },
  {
    label: "嘉義老家",
    e: "J",
    color: getColor(1).bgColor,
    amount: 620,
  },
  {
    label: "公司",
    e: "G",
    color: getColor(2).bgColor,
    amount: 2250,
  },
];
export const Wallet = () => {
  return (
    <YStack mt="$5" gap="$3">
      <FamilyExpenses data={FAMILY_SPENDING_DATA} />
      <TransactionHistory />
    </YStack>
  );
};

export default Wallet;
